(() => {
  'use strict';
  if (window.__SQ_LAUNCH_FINAL_CLEAN_V4__) return;
  window.__SQ_LAUNCH_FINAL_CLEAN_V4__ = true;
  window.__SQ_LAUNCH_FINAL_CLEAN_V3__ = true;
  window.__SQ_LAUNCH_FINAL_CLEAN_V2__ = true;
  window.__SQ_LAUNCH_FINAL_CLEAN_V1__ = true;

  const path = location.pathname.replace(/\/+$/,'').toLowerCase();

  const retireNode = node => {
    if (!(node instanceof Element)) return;
    const targets = [];
    if (node.hasAttribute('data-auto-in-stock-url')) targets.push(node);
    node.querySelectorAll?.('[data-auto-in-stock-url]').forEach(el => targets.push(el));
    targets.forEach(el => {
      el.setAttribute('data-sq-auto-in-stock-retired', 'true');
      el.removeAttribute('data-auto-in-stock-url');
      if (el.dataset) delete el.dataset.autoInStockUrl;
    });
  };

  const retireAutoInStock = () => document.querySelectorAll('[data-auto-in-stock-url]').forEach(retireNode);

  retireAutoInStock();
  document.addEventListener('DOMContentLoaded', retireAutoInStock, { once: true, capture: true });
  window.addEventListener('pageshow', event => { if (event.persisted) retireAutoInStock(); }, { passive: true });

  if (window.MutationObserver && document.documentElement) {
    const autoObserver = new MutationObserver(records => {
      for (const record of records) {
        if (record.type === 'attributes') retireNode(record.target);
        else record.addedNodes.forEach(retireNode);
      }
    });
    autoObserver.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-auto-in-stock-url']
    });
    window.__SQ_AUTO_IN_STOCK_RETIRE_OBSERVER__ = autoObserver;
  }

  if (path === '/pages/style-journal' || path === '/pages/vlog' || path === '/blogs/style-journal' || path.startsWith('/blogs/style-journal/')) {
    document.documentElement.classList.add('sq-editorial-share-reference');
  }

  const releaseTransitions = () => {
    document.getElementById('view-transition-render-blocker')?.remove();
    document.querySelectorAll('script[blocking="render"][src*="view-transitions"]').forEach(script => script.removeAttribute('blocking'));
  };
  releaseTransitions();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', releaseTransitions, { once: true, capture: true });
})();
